<template>
  <div class="answer-section">
    <div class="container" v-loading="loading">
      <div class="answer-content">
        <div class="answer-column">
          <div v-for="(item,index) in list" :key="index" @click="handleClick(item)">
            <div class="u-flex u-row-between search-box">
              <div class="answer-item">
                {{ item.title }}
              </div>
              <div class="u-font-14">{{ new Date(item.create_time*1000).toLocaleString() }}</div>
            </div>
            <el-divider v-if="index<list.length-1"></el-divider>
          </div>
          <el-empty :image-size="200" v-if="list.length === 0"></el-empty>
        </div>
      </div>
      <!-- 分页 -->
        <div class="u-flex u-row-center u-m-t-60" v-if="list.length !== 0">
            <el-pagination
              layout="prev, pager, next"
              background
              :total="records"
              :current-page.sync="page"
              :page-size.sync="limit"
              @current-change="getlist"
              @size-change="getlist"
            />
        </div>
    </div>
  </div>
</template>

<script>
import { getnews } from '@/api/index'

export default {
  data() {
    return {
      loading: false,
      keyword: '',
       // 可以在这里添加数据
      list: [],
      records: 0,
      page: 1,
      limit: 10,
    }
  },
  watch: {
    // 监听路由参数变化，当商品ID改变时重新加载数据
    '$route.query.q': {
      handler: function(newId) {
        if (newId) {
          this.keyword = newId
          this.getlist()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.keyword = this.$route.query.q
    this.getlist()
  },
  methods: {
    getlist() {
      this.loading = true
      getnews({
        keyword: this.keyword,
        news_type_id: '',
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.code === 1) {
          this.list = res.data.list
          this.records = res.data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClick(item) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped>
.answer-section{
  padding: 60px 0;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.answer-content{
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0px 3px 8px 1px rgba(60,97,135,0.05);
}
.answer-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
}

.answer-item {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.answer-item:hover {
  color: #0066cc !important;
}
.search-box {
  transition: color 0.3s;
  line-height: 32px;
  cursor: pointer;
  /* padding: 8px 0; */
  color: #666;
}
.search-box:hover {
  color: #0066cc !important;
}
.first-item {
  font-size: 14px;
  color: #FF0B34;
  font-weight: 600;
}
.second-item {
  font-size: 14px;
  color: #FF6600;
  font-weight: 600;
}
.third-item {
  font-size: 14px;
  color: #FCC633;
  font-weight: 600;
}
.other-item {
  font-size: 14px;
  color: #999;
  font-weight: 600;
}
</style>